import { useMemo } from 'react'
import { patientName } from 'Data/format.js'
import { v4 as uuid } from 'uuid'
import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  let include_insurance_payors = useDataValue({
    context: 'selected',
    path: 'include_insurance_payors',
    viewPath: props.viewPath,
  })
  let include_person_payors = useDataValue({
    context: 'selected',
    path: 'include_person_payors',
    viewPath: props.viewPath,
  })

  return useMemo(() => {
    if (!data) return data

    let payment_accounts = data.payment_accounts
      .filter(
        i =>
          (typeof i.insured_id === 'number' && include_insurance_payors) ||
          (!i.insured_id && include_person_payors)
      )
      .map(i => {
        if (typeof i.insured_id === 'number') {
          let is_new = typeof i.payment_account_id !== 'number'

          return {
            // include insured_id in case the insurance subscription if for the same insurance carrier
            // but a different subscription member (e.g. both mom and dad both have an insurance with the same insurance carrier)
            id: `${i.payment_account_id || uuid()}--${i.insured_id}`,
            text: `${i.insurance_company.carrier_name} (Group/Plan: ${
              i.insurance_plan.number
            }) - ${patientName(i.payor)}${is_new ? ' [NEW]' : ''}`,
            data: {
              payer_person: i.payor,
              account_type: 'InsurancePaymentAccount',
              payment_account_id: i.payment_account_id,
              insured_id: i.insured_id,
              insurance_company_id: i.insurance_company.id,
              is_new,
            },
          }
        } else {
          let is_new = typeof i.payment_account_id !== 'number'

          // uuid, in case payment account does not exists, new one will be created
          // e.g. responsible people, patient itself, they might not have payment accounts if they are new
          return {
            id: `${i.payment_account_id || uuid()}`,
            text: `${patientName(i.payor)}${is_new ? ' [NEW]' : ''}`,
            data: {
              payer_person: i.payor,
              account_type: 'PersonPaymentAccount',
              payment_account_id: i.payment_account_id || null,
              is_new,
            },
          }
        }
      })

    payment_accounts.sort((a, b) => a.text.localeCompare(b.text))

    return payment_accounts
  }, [data, include_insurance_payors, include_person_payors])
}
